import { IDropdownSelector } from "@Modules/common/Form/FormInputs/DropdownSelector/IDropdownSelector";
import { ISlots } from "./ISlots";

const useSlotsData = (props: ISlots.IProps) => {
    const {
        handleDateChange,
        handleSlotChange,
        selectedSlots,
        ticketCount,
        dateList,
        slots,
        slotDisplay,
        removeSlot,
        index,
    } = props;

    const slotDateOptions = dateList.map((d: string) => ({
        value: d,
        label: d,
        index,
    }));

    const slotDateValue =
        slotDateOptions.find(
            (option: { value: any }) =>
                option.value === selectedSlots?.[index]?.date
        ) ?? null;

    const slotTimeOptions = (
        selectedSlots && index in selectedSlots
            ? slotDisplay.filter(
                  (s: { startDate: any }) =>
                      s.startDate === selectedSlots[index].date
              )
            : []
    ).map((t: { startTime: any; uuid: any }) => ({
        label: t.startTime,
        value: t.uuid,
        index,
        disabled: slots.includes(t.uuid),
    }));

    const slotTimeValue =
        slotTimeOptions.find(
            (option: { value: any }) =>
                option.value === selectedSlots?.[index]?.uuid
        ) ?? null;

    const disableEditing = !selectedSlots?.[index]?.date;
    const isOptionDisabled = (option: IDropdownSelector.Option) =>
        option?.disabled;

    return {
        slotDateValue,
        slotTimeValue,
        slotDateOptions,
        slotTimeOptions,
        disableEditing,
        isOptionDisabled,
        handleDateChange,
        handleSlotChange,
        ticketCount,
        removeSlot,
        index,
    };
};

export default useSlotsData;
